import { Ref } from 'vue';

import {
  FieldHtmlNameUtil,
  FieldHtmlNameType,
  FormIdUtil,
  HekateBusFieldValue,
  HekateDisplayForm,
  HekateEventBusCallbackParams,
} from 'www-shared';

import hekateBus from '../../../../../bus';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class ReferAFriendReferrerProgressiveProfile extends CommonPreFilledProgressiveProfile {
  /** When this form is submitted attempt to submit the hidden referred user form on the page. */
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>
  }): void {
    super.realtimeBranchModifications({ formDefinition });

    hekateBus.addEventListener('form-successfully-submitted', (evt: HekateEventBusCallbackParams<{formDefinition: HekateDisplayForm | null}>) => {
      const submittedForm = evt.data.formDefinition;
      if (submittedForm === null || FormIdUtil.names.referAFriendReferrer !== submittedForm.id) {
        return;
      }

      const targetFieldNames: FieldHtmlNameType[] = [
        'referredFirstName',
        'referredLastName',
        'referredEmailAddress',
        'referredCompanyName',
        'referredJobTitle',
        'referredPhoneNumber',
        'email',
        'privacyConsentAccepted',
      ];

      const values: HekateBusFieldValue[] = targetFieldNames.map((fieldName) => {
        const found = ExternalUtil.noRefFindDisplayFieldOrThrow({
          formDefinition: submittedForm,
          fieldName,
        });

        const result: HekateBusFieldValue = {
          fieldName,
          fieldValue: found.val,
        };

        return result;
      });

      const firstName = ExternalUtil.noRefFindDisplayFieldOrThrow({
        formDefinition: submittedForm,
        fieldName: FieldHtmlNameUtil.firstName,
      }).val;

      const lastName = ExternalUtil.noRefFindDisplayFieldOrThrow({
        formDefinition: submittedForm,
        fieldName: FieldHtmlNameUtil.lastName,
      }).val;

      const email = ExternalUtil.noRefFindDisplayFieldOrThrow({
        formDefinition: submittedForm,
        fieldName: FieldHtmlNameUtil.email,
      }).val;

      values.push({
        fieldName: FieldHtmlNameUtil.referrerFullName,
        fieldValue: `${firstName} ${lastName}`,
      });

      values.push({
        fieldName: FieldHtmlNameUtil.utmSource,
        fieldValue: `Referred by: ${email}`,
      });

      values.push({
        fieldName: FieldHtmlNameUtil.utmMedium,
        fieldValue: 'Referral',
      });

      hekateBus.dispatchEvent('form-inject-and-submit', values);
    });
  }
}
